import React, { Component } from 'react';
import styled from 'styled-components';
import Dropup from 'react-icons/lib/fa/caret-up';
import { Flex, media } from 'lib/style-utils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as uiActions from 'modules/ui';
import AnotherBrands from './AnotherBrands';

const Wrapper = Flex.extend`
  width: 100%;
  height: 120px;
  padding: 0 100px;
  justify-content: space-between;
  border-top: 1px solid #ededed;
  z-index: 10;
  transition: all .5s;

  ${media.tablet`
    padding: 0 50px;
  `}
  ${media.w800`
    height: auto;
  `}
  ${media.mobile`
    display: block;
    padding: 0;
  `}
`;

/** Gurm by H Logo */
const Logo = styled.div`
  & img {
    width: 100px;

    ${media.w800`
      width: 80px;
    `}
  }

  ${media.w800`
    margin: 30px 0;
  `}
  ${media.mobile`
    display: block;
    margin-left: 39px;
  `}
`;

/** Link Navigation */
const LinkWrapper = Flex.extend`
  width: 49%;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #888888;
  transition: all .5s;

  & > p {
    position: relative;
  }
  & .dropIcon {
    position: absolute;
    top: -3px;
    left: -21px;
  }
  & .dropIcon > svg {
    transform: ${props => props.showAnotherBrands ? 'rotateZ(180deg)' : 'rotateZ(0deg)'};
    transition: all .2s ease-in-out;
  }

  & > a, p {
    ${media.w800`
      display: block;
    `}
    ${media.mobile`
      display: inline-block;
      margin: 0 0 34px 39px;
      font-size: 13px;

      &.mobile.hidden {
        display: none;
      }
      &.mobile.show {
        display: block;
      }
    `}
  }

  .mobile.show {
    display: none;
  }

  ${media.w1200`
    width: 70%;
  `}
  ${media.w800`
    width: 85%;
    font-size: 13px;
  `}
  ${media.mobile`
    width: 180px;
    display: block;
    margin-top: 10px;

    & .dropIcon {
      position: static;
      vertical-align: text-top;
    }
  `}
`;

/** Copyright */
const Copyright = Wrapper.extend`
  height:74px;
  color: #b4b4b4;
  background: #f9f9f9;
  font-size: 13px;
  font-family: Lato;

  ${media.w800`
    height:74px;
  `}
  ${media.mobile`
    display: flex;
    height:70px;
    font-size: 11px;

    & .left {
      margin-left: 39px;
    }
    & .right {
      margin-right: 39px;
    }
  `}
`;

class Footer extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  handleShowAnother = () => {
    const { UIActions } = this.props;
    UIActions.showAnother();
  }

  render() {
    const { showAnotherBrands } = this.props;
    const { handleShowAnother } = this;

    return (
      <div style={{zIndex: '10'}}>
      <Wrapper>
        <Logo><a href="http://www.gurmbyh.com" target="_blank" rel="noopener noreferrer"><img src="/images/logo/gurmbyh.png" alt=""/></a></Logo>

        {showAnotherBrands ? <AnotherBrands/> : null}

        <LinkWrapper showAnotherBrands={showAnotherBrands}>
          <p className="mobile hidden" style={{cursor: 'pointer'}} onClick={handleShowAnother}><span className="dropIcon"><Dropup style={{fontSize: '20px'}}></Dropup></span> ANOTHER BRAND</p>
          <p className="mobile show" style={{cursor: 'pointer'}} onClick={handleShowAnother}>ANOTHER BRAND<span className="dropIcon"><Dropup style={{fontSize: '20px'}}></Dropup></span> </p>
          <a href="http://www.gurmbyh.com" target="_blank" rel="noopener noreferrer">GURM BY H</a>
          <a href="http://www.gurmbyh.com/product/list.html?cate_no=115" target="_blank" rel="noopener noreferrer">ONLINE SHOP</a>
          <a href="http://gurmbyh.blog.me" target="_blank" rel="noopener noreferrer">BLOG</a>
          <a href="https://www.instagram.com/gurmbyh_official" target="_blank" rel="noopener noreferrer">INSTAGRAM</a>
        </LinkWrapper>
      </Wrapper>
      <Copyright>
        <p className="left">DISTRIBUTOR GURM BY H</p>
        <p className="right">&copy; 2017 GURM BY H</p>
      </Copyright>
    </div>
    );
  };
}

export default connect(
  (state) => ({
    showAnotherBrands: state.ui.get('showAnotherBrands')
  }),
  (dispatch) => ({
    UIActions: bindActionCreators(uiActions, dispatch)
  })
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Shared/Footer.js